module.exports = __webpack_public_path__ + "img/Voice 2.2304c0d2.svg";